import type { NotificationMethods } from '~/helpers/notificationPrefs';
import { PrefCheckbox } from './PrefCheckbox';

type Props = {
  methods: NotificationMethods;
  disabled?: boolean;
  onToggle: (
    path:
      | 'messages.email'
      | 'messages.sms'
      | 'jobReminders.email'
      | 'jobReminders.sms'
      | 'jobSummaries.email'
      | 'statusChanges.email',
    next: boolean
  ) => void;
};

export const MethodsSection = ({ methods, disabled, onToggle }: Props) => {
  return (
    <section className='flex flex-col gap-4'>
      <h2 className='text-lg font-semibold text-primary'>
        Notification Methods
      </h2>
      <div className='grid w-fit grid-cols-[minmax(11rem,auto)_3rem_3rem] items-start gap-x-4 gap-y-5'>
        <div />
        <div className='mx-auto text-sm font-semibold text-primary'>Email</div>
        <div className='mx-auto text-sm font-semibold text-primary'>SMS</div>

        <div>
          <div className='text-primary'>Job Messages</div>
          <p className='mt-1 max-w-[16rem] text-xs italic text-tertiary'>
            At least one of Email or SMS is always required for Job Messages.
          </p>
        </div>
        <PrefCheckbox
          aria-label='Job Messages Email'
          checked={methods.messages.email}
          disabled={disabled}
          onChange={(next) => onToggle('messages.email', next)}
        />
        <PrefCheckbox
          aria-label='Job Messages SMS'
          checked={methods.messages.sms}
          disabled={disabled}
          onChange={(next) => onToggle('messages.sms', next)}
        />

        <div className='text-primary'>Job Reminders</div>
        <PrefCheckbox
          aria-label='Job Reminders Email'
          checked={methods.jobReminders.email}
          disabled={disabled}
          onChange={(next) => onToggle('jobReminders.email', next)}
        />
        <PrefCheckbox
          aria-label='Job Reminders SMS'
          checked={methods.jobReminders.sms}
          disabled={disabled}
          onChange={(next) => onToggle('jobReminders.sms', next)}
        />

        <div className='text-primary'>Job Summaries</div>
        <PrefCheckbox
          aria-label='Job Summaries Email'
          checked={methods.jobSummaries.email}
          disabled={disabled}
          onChange={(next) => onToggle('jobSummaries.email', next)}
        />
        <div />

        <div className='text-primary'>Status Changes</div>
        <PrefCheckbox
          aria-label='Status Changes Email'
          checked={methods.statusChanges.email}
          disabled={disabled}
          onChange={(next) => onToggle('statusChanges.email', next)}
        />
        <div />
      </div>
    </section>
  );
};
